module.exports = __webpack_public_path__ + "img/undraw_not_found.f186c73d.svg";